module.exports = __webpack_public_path__ + "img/template-desktop-blank.7d6bebc4.svg";